const INACTIVE_MARKET_STATUS_LABEL: Record<string, string> = {
  EXPD: "Expired",
  ACQU: "Acquired",
  DLST: "Ticker Delisted",
  POST: "Postponed",
  PEND: "Pending Listing",
  INAC: "Inactive",
  TKCH: "Ticker Change",
  UNLS: "Unlisted",
  LIQU: "Liquidated",
};

export function isTickerActive(marketStatus: string): boolean {
  return !INACTIVE_MARKET_STATUS_LABEL[marketStatus];
}

export function getMarketStatusLabel(marketStatus: string) {
  return INACTIVE_MARKET_STATUS_LABEL[marketStatus] || marketStatus;
}
